import { CircularProgress, Stack } from '@mui/material';
import { PageCard } from '../../../Compounds/CardWithTitle/PageCard';
import { SelectMenu } from '../../../Atoms/SelectMenu';
import { DualListBox } from '../../../Compounds/DualListBox';
import { useBlockList } from '../../../../Api/Admin/BlockList/useBlockList';
import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../../utils/styleHelpers';
import { InternalUser } from '../../../../types';

const BLOCK_LIST_TYPES = [{ value: 'comment_mention', text: 'Comment @Mention' }];
const DEFAULT_LIST_TYPE = BLOCK_LIST_TYPES[0].value;

const getUserId = (user: InternalUser): string => user.id;

const userLabel = (user: InternalUser): string =>
  user.name || `${user.first_name} ${user.last_name}`.trim() || user.email;

export const BlockListTab = () => {
  const { internalUsers, listType, stagedIds, loading, saving, dirty, setStagedIds, selectListType, save, cancel } =
    useBlockList(DEFAULT_LIST_TYPE);

  return (
    <PageCard
      title="Block List"
      dataCy="block-list-tab"
      enableCollapse={false}
      childrenWrapperClass="min-h-80">
      <Stack spacing={2}>
        <div className="w-72">
          <SelectMenu
            name="blockListType"
            ariaLabel="Block list"
            options={BLOCK_LIST_TYPES}
            value={listType}
            handleSelect={(event) => selectListType(event.target.value)}
            dataCy="block-list-type"
          />
        </div>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <>
            <DualListBox<InternalUser>
              items={internalUsers}
              selectedIds={stagedIds}
              onChange={setStagedIds}
              getId={getUserId}
              getLabel={userLabel}
              availableTitle="Full list of users"
              selectedTitle="Blocked Users"
              searchPlaceholder="Search users"
              emptyText="No users"
            />
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end">
              <button
                type="button"
                className={DEFAULT_CANCEL_BUTTON_STYLE}
                disabled={!dirty || saving}
                onClick={cancel}>
                Cancel
              </button>
              <button
                type="button"
                className={DEFAULT_ADVANCE_BUTTON_STYLE}
                disabled={!dirty || saving}
                onClick={save}>
                Save
              </button>
            </Stack>
          </>
        )}
      </Stack>
    </PageCard>
  );
};
